module.exports = __webpack_public_path__ + "static/media/crow_fly_to_river.4afe10e9.gif";